module.exports = __webpack_public_path__ + "static/media/cloud_2.25a80471.png";